import "@fontsource-variable/instrument-sans";
import "@fontsource-variable/source-serif-4/opsz.css";
import "@fontsource-variable/jetbrains-mono";
// Arabic partners (Arabic letters only; nothing downloads until a page shows Arabic).
import "@fontsource/ibm-plex-sans-arabic/arabic-400.css";
import "@fontsource/ibm-plex-sans-arabic/arabic-500.css";
import "@fontsource-variable/noto-naskh-arabic/wght.css";
import "./index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { initLocale } from "@ghezaa/ui";
import { createAppQueryClient, loadCatalogs, LocaleProvider } from "@ghezaa/shell";
import { router } from "./router";

const queryClient = createAppQueryClient();

// The language is settled once per page load (choosing another reloads), then its catalogues load before the first frame.
// English only, like Sourcing: decided by the user on 4 Nov 2026 (docs/sales-plan.md, decisions), an exception to
// docs/languages-plan.md decision 6. Arabic would be a phase of its own.
initLocale({ pseudo: import.meta.env.DEV, languages: ["en"] });

void loadCatalogs((locale) => import(`./locales/${locale}.po`)).then(() =>
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <LocaleProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </LocaleProvider>
    </StrictMode>,
  ),
);
